import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { http, errText } from "../lib/api";
import { Logo } from "../components/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      localStorage.setItem("xsquad_admin_token", data.token);
      nav("/admin");
    } catch (err) {
      setError(errText(err));
      setLoading(false);
    }
  };

  const field = "w-full border-2 border-[#0B0B0B] bg-white px-4 py-4 font-semibold outline-none focus:border-[#E10600] transition-colors duration-200";
  return (
    <main data-testid="admin-login-page" className="min-h-[100svh] bg-[#F6F3EF] flex items-center justify-center px-5 pt-28 pb-16">
      <form onSubmit={submit} className="w-full max-w-md bg-white border-2 border-[#0B0B0B] p-8 shadow-[10px_10px_0_#E10600]">
        <Logo />
        <h1 className="font-display uppercase text-5xl mt-8">X Check In</h1>
        <label className="block mt-8 font-mono-x uppercase text-xs tracking-[0.2em] mb-2" htmlFor="ae">Email</label>
        <input id="ae" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={field} data-testid="admin-email-input" />
        <label className="block mt-5 font-mono-x uppercase text-xs tracking-[0.2em] mb-2" htmlFor="ap">Password</label>
        <input id="ap" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={field} data-testid="admin-password-input" />
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm font-bold text-[#E10600]">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit" className="mt-8 w-full bg-[#E10600] text-white py-4 font-display uppercase text-xl flex items-center justify-center gap-2 transition-colors duration-200 hover:bg-[#0B0B0B] disabled:opacity-60">
          {loading && <Loader2 className="w-5 h-5 animate-spin" />} Enter
        </button>
      </form>
    </main>
  );
}
